import React from 'react';
import { Helmet } from 'react-helmet-async';
import './About.css';

const About = ({ settings }) => {
  return (
    <>
      <Helmet>
        <title>About Us - NieHairLabel</title>
        <meta name="description" content="Learn about NieHairLabel and our mission to provide premium quality wigs" />
      </Helmet>
      <div className="about-page">
        <div className="container">
          <h1>About NieHairLabel</h1>
          <div className="about-content">
            <p>
              Welcome to NieHairLabel, your trusted source for premium quality wigs. 
              We are dedicated to providing our customers with the finest selection of wigs 
              that combine style, quality, and comfort.
            </p>
            <p>
              Our mission is to help you look and feel your best with our carefully curated 
              collection of wigs. Each product in our inventory is selected for its superior 
              quality and craftsmanship.
            </p>
            <p>
              At NieHairLabel, we believe that everyone deserves to feel confident and beautiful. 
              That's why we offer a wide range of styles, colors, and sizes to suit every need 
              and preference.
            </p>
            <h2>Our Commitment</h2>
            <ul>
              <li>Premium Quality Products</li>
              <li>Excellent Customer Service</li>
              <li>Fast and Reliable Shipping</li>
              <li>100% Satisfaction Guarantee</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;



